export default "__VITE_ASSET__DaE8egsa__"